import benefitAmounts from '../data/dashboard/benefitAmounts.json';

export const getAllTableData = (persona: any) => {
    const data: any = benefitAmounts['data'];

    return data[persona];
};
